import { SANDBOX_SERVICE_DOMAIN, STG_SERVICE_DOMAIN, TEST_SERVICE_DOMAIN, WEB_DOMAINS } from "./domains";
import { HOSTNAME } from "./hostname";
import { LANGUAGE } from "./language";

export const API_DOMAINS = {
  lt: {
    sandbox: "https://sandbox-api-public.perlas.lt",
    test: "https://test-api-public.perlas.lt",
    stg: "https://staging-api-public.dataop.lt",
    prod: "https://api-public.dataop.lt",
  },
  pl: {
    //todo pl - recheck final api URLs for PL here
    sandbox: "https://pl-sandbox-api-public.perlas.lt",
    test: "https://pl-test-api-public.perlas.lt",
    stg: "https://pl-staging-api-public.dataop.lt",
    prod: "https://pl-api-public.dataop.lt",
  },
};

const getApiDomain = () => {
  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].sandbox || HOSTNAME === SANDBOX_SERVICE_DOMAIN) {
    return API_DOMAINS[LANGUAGE].sandbox;
  }

  if (
    HOSTNAME === WEB_DOMAINS[LANGUAGE].test ||
    HOSTNAME === TEST_SERVICE_DOMAIN ||
    HOSTNAME?.includes("localhost") ||
    window.location.protocol === "file:"
  ) {
    return API_DOMAINS[LANGUAGE].test;
  }

  if (HOSTNAME === WEB_DOMAINS[LANGUAGE].stg || HOSTNAME === STG_SERVICE_DOMAIN) {
    return API_DOMAINS[LANGUAGE].stg;
  }
  //making default return of prod domain
  return API_DOMAINS[LANGUAGE].prod;
};

export const HISTORICAL_PAYMENT_FLAG = "history=1";

export const API_DOMAIN = getApiDomain();
